import { useCallback, useEffect, useState } from "react";

const LIVE_POLL_MS = 15000;

export function useMerchantLiveSync(
  enabled: boolean,
  paused = false
): {
  tick: number;
  bump: () => void;
} {
  const [tick, setTick] = useState(0);
  const bump = useCallback(() => {
    setTick((current) => current + 1);
  }, []);

  useEffect(() => {
    if (!enabled || paused) {
      return;
    }
    const refreshIfVisible = () => {
      if (document.visibilityState === "visible") {
        bump();
      }
    };
    const interval = window.setInterval(refreshIfVisible, LIVE_POLL_MS);
    document.addEventListener("visibilitychange", refreshIfVisible);
    window.addEventListener("focus", refreshIfVisible);
    return () => {
      window.clearInterval(interval);
      document.removeEventListener("visibilitychange", refreshIfVisible);
      window.removeEventListener("focus", refreshIfVisible);
    };
  }, [enabled, paused, bump]);

  return { tick, bump };
}
